"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLinesEllipsis = _interopRequireDefault(require("react-lines-ellipsis"));

var _html = _interopRequireDefault(require("react-lines-ellipsis/lib/html"));

var _responsiveHOC = _interopRequireDefault(require("react-lines-ellipsis/lib/responsiveHOC"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var commonProps = {
  basedon: 'letters',
  style: {
    'overflowWrap': 'break-word',
    'wordBreak': 'break-word',
    'wordWrap': 'break-word',
    'whiteSpace': 'pre-wrap'
  }
};
var Ellipsis = (0, _react.forwardRef)(function (props, ref) {
  return (0, _core.jsx)(_reactLinesEllipsis.default, _extends({
    ref: ref,
    text: props.text,
    maxLine: props.maxLines,
    ellipsis: '...'
  }, commonProps));
});
var HtmlEllipsis = (0, _react.forwardRef)(function (props, ref) {
  return (0, _core.jsx)(_html.default, _extends({
    ref: ref,
    unsafeHTML: props.text,
    maxLine: props.maxLines,
    ellipsisHTML: '...'
  }, commonProps));
});

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  maxLines: 3,
  isHtml: false
}), (0, _recompose.setPropTypes)({
  text: _propTypes.default.string.isRequired,
  maxLines: _propTypes.default.number,
  isHtml: _propTypes.default.bool
}), (0, _recompose.withProps)(function (_ref) {
  var isHtml = _ref.isHtml;
  return {
    Component: (0, _responsiveHOC.default)()(isHtml ? HtmlEllipsis : Ellipsis)
  };
}), (0, _recompose.setDisplayName)('Ellipsis'))(function (_ref2) {
  var Component = _ref2.Component,
      props = _objectWithoutProperties(_ref2, ["Component"]);

  return (0, _core.jsx)(Component, props);
});

exports.default = _default;